import slideDown from '../util/slide-down';
import slideUp from '../util/slide-up';

const slideToggle = (target, duration = 500) => {
  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
};

export default slideToggle;
